import { createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "./components/common/Errorboundry";
import PrivateRoute from "./components/common/PrivateRoute";
import Home from "./pages/public/Home";
import RootLayout from "./pages/public/RootLayout";
import SignUp from "./pages/public/SignUp";
import Login from "./pages/public/Login";
import { ForgotPassword } from "./pages/public/ForgotPassword";
import Dashboard from "./pages/admin/Dashboard/Dashboard";
import Profile from "./pages/admin/Dashboard/Profile";
import Search from "./pages/public/Search";
import CreateCompany from "./pages/public/CreateCompany";
import RootLayoutAdmin from "./pages/admin/RootLayoutAdmin";
import { CompanyProfile } from "./pages/public/Company/[id]";
import MyCompany from "./pages/admin/Dashboard/MyCompanies";
import Following from "./pages/admin/Dashboard/Following";
import Purchased from "./pages/admin/Dashboard/Purchased";
import { ClaimCompany } from "./pages/public/Company/[claimCompany]";
import Request from "./pages/admin/Dashboard/Request";
import CompanyEditProfile from "./pages/admin/CompanyEditProfile";
import { Help } from "./pages/admin/Dashboard/Help";
import { Payment } from "./components/public/Payment/Payment";
import { PaymentDetails } from "./components/public/Payment/Plans/PaymentDetails";
import { SuccessfulPayment } from "./components/public/Payment/Plans/SuccessfulPayment";
import Billing from "./pages/admin/Dashboard/Billing";
import { TrevexPrivacyPolicy } from "./pages/public/TrevexPrivacyPolicy";
import { TermsAndCondition } from "./pages/public/TermsAndcondition";
import Verification from "./components/common/Verification";
import Enterprise from "./pages/admin/Dashboard/Enterprise";
import EnterpriseActivityLogTable from "./components/admin/Dashboard/dashboard/EnterpriseActivityLogTable";
import { EnterpriseTrackedCompanies } from "./components/admin/Dashboard/mycompanies/EnterpriseTrackedCompanies";
import GptPrompts from "./pages/public/GptPrompts";
// import GPT_prompt from "./pages/public/GPT_prompt";
import { GPT_prompt } from "./components/admin/Dashboard/GPT_prompt";
import ThankYou from "./pages/public/ThankYou";
import TradeLicence from "./pages/public/Upload/TradeLicence";
import PaymentRefHub from "./pages/admin/Dashboard/PaymentRefHub";
import PaymentRefQnA from "./pages/admin/Dashboard/PaymentRefQnA";

export const router = createBrowserRouter([
  {
    path: "/",
    children: [{ path: "/", element: <ErrorBoundary><PrivateRoute token={false}><Home /></PrivateRoute></ErrorBoundary> }],
  },
  {
    path: "gpt-prompts/access",
    element: <ErrorBoundary><PrivateRoute token={false}><GPT_prompt /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/",
    element: <ErrorBoundary><PrivateRoute token={false}><RootLayout liftHeader={true} /></PrivateRoute></ErrorBoundary>,
    children: [
      { path: "/gpt-prompts", element: <ErrorBoundary><PrivateRoute token={false}><GPT_prompt /></PrivateRoute></ErrorBoundary> },
    ],
  },
  {
    path: "/",
    element: <ErrorBoundary><PrivateRoute token={false}><RootLayout /></PrivateRoute></ErrorBoundary>,
    children: [
      { path: "/", element: <ErrorBoundary><PrivateRoute token={false}><Home /></PrivateRoute></ErrorBoundary> },
      { path: "/search", element: <ErrorBoundary><PrivateRoute token={false}><Search /></PrivateRoute></ErrorBoundary> },
      { path: "/gpt-prompts/search", element: <ErrorBoundary><PrivateRoute token={false}><GPT_prompt /></PrivateRoute></ErrorBoundary> },
      { path: "/gpt-prompts/search/:id", element: <ErrorBoundary><PrivateRoute token={false}><GPT_prompt /></PrivateRoute></ErrorBoundary> },
      { path: "/search/:id", element: <ErrorBoundary><PrivateRoute ><CompanyProfile /></PrivateRoute></ErrorBoundary> },
      { path: "/create-company", element: <ErrorBoundary><PrivateRoute><CreateCompany /></PrivateRoute></ErrorBoundary> },
    ],
  },
  {
    path: "/update/trade-license/:token",
    element: <ErrorBoundary><PrivateRoute token={false}><TradeLicence /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/claim/:id",
    element: <ErrorBoundary><PrivateRoute><ClaimCompany /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/sign-up",
    element: <ErrorBoundary><PrivateRoute token={false}><SignUp /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/thank-you",
    children: [{ path: "/thank-you", element: <ErrorBoundary><PrivateRoute token={false}><ThankYou /></PrivateRoute></ErrorBoundary> }],
  },
  // {
  //   path: "/thank-you",
  //   element: <ErrorBoundary><PrivateRoute token={false}><ThankYou /></PrivateRoute></ErrorBoundary>,
  // },
  {
    path: "/login",
    element: <ErrorBoundary><PrivateRoute token={false}><Login /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/reset-password",
    element: <ErrorBoundary><PrivateRoute token={false}><ForgotPassword route={"reset"} /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/set-password",
    element: <ErrorBoundary><PrivateRoute token={false}><ForgotPassword route={"set"} /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/plans",
    element: <ErrorBoundary><PrivateRoute token={false}><Payment /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/plans/paymentdetails",
    element: <ErrorBoundary><PrivateRoute><PaymentDetails /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/plans/paymentsuccessful",
    element: <ErrorBoundary><PrivateRoute><SuccessfulPayment /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/dashboard",
    element: <ErrorBoundary><PrivateRoute><RootLayoutAdmin /></PrivateRoute></ErrorBoundary>,
    children: [
      { path: "/dashboard", element: <ErrorBoundary><PrivateRoute><Dashboard /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/profile", element: <ErrorBoundary><PrivateRoute><Profile /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/my-companies", element: <ErrorBoundary><PrivateRoute><MyCompany /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/enterprise", element: <ErrorBoundary><PrivateRoute><Enterprise /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/enterprise/:id", element: <ErrorBoundary><PrivateRoute><EnterpriseTrackedCompanies /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/enterprise/act-log", element: <ErrorBoundary><PrivateRoute><EnterpriseActivityLogTable /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/following", element: <ErrorBoundary><PrivateRoute><Following /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/purchased", element: <ErrorBoundary><PrivateRoute><Purchased /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/payment-ref", element: <ErrorBoundary><PrivateRoute><PaymentRefHub /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/payment-ref/form", element: <ErrorBoundary><PrivateRoute><PaymentRefQnA /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/request", element: <ErrorBoundary><PrivateRoute><Request /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/billing", element: <ErrorBoundary><PrivateRoute><Billing /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/help", element: <ErrorBoundary><PrivateRoute><Help /></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/gpt", element: <ErrorBoundary><PrivateRoute><GPT_prompt to={"gpt"}/></PrivateRoute></ErrorBoundary> },
      { path: "/dashboard/article", element: <ErrorBoundary><PrivateRoute><GPT_prompt to={"article"} /></PrivateRoute></ErrorBoundary> },

    ],
  },
  {
    path: "/edit/:id",
    element: <ErrorBoundary><PrivateRoute><CompanyEditProfile /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/privacy-policy",
    element: <ErrorBoundary><PrivateRoute token={false}><TrevexPrivacyPolicy /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/terms-and-condition",
    element: <ErrorBoundary><PrivateRoute token={false}><TermsAndCondition /></PrivateRoute></ErrorBoundary>,
  },
  {
    path: "/verification",
    element: (
      <ErrorBoundary><Verification /></ErrorBoundary>
    ),
  },
  {
    path: "*",
    element: (
      <ErrorBoundary><PrivateRoute token={false}>
        <Login />
      </PrivateRoute></ErrorBoundary>
    ),
  },
]);
